<template>
  <!--停车信息组件-->
  <div style="height: 100%;width: 100%;">
    <div class="return-btn" v-if="stopBtn">
      <Button icon="ios-menu" @click="showStopInfo">停车信息</Button>
    </div>
    <div style=" width:300px;height: 30px;position: absolute;right: 0;top:0;z-index: 111" v-if="stopShow">
      <Button long icon="ios-arrow-forward" @click="hideStopInfo">停车信息</Button>
    </div>
    <!--停车信息框-->
    <div class="stop-info-bar" v-if="stopShow">
      <div style="height: 30px;width: 100%;"></div>
      <Card class="info-card" v-for="item,index in stopInfo">
        <div class="left">
          <!--        <img class="img" :src="'/pois/poi_' + (index + 1) + '.png'" height="50%" width="50%"/>-->

          <!--        <div style="position: absolute; width: 170px; height: 89px;top:65px; left: 160px;">-->
          <img src='/poi.png' style="margin-top: 8px; width: 17px; height: 27px; vertical-align: top;">
          <span v-if="index<9" style="position: absolute;left: 21px;top:25px;color: #ffffff">{{index+1}}</span>
          <span v-if="index>8" style="position: absolute;left: 18px;top:25px;color: #ffffff">{{index+1}}</span>
          <!--        </div>-->

        </div>
        <div class="right" @click="toStopLocation(item)">
          <p style="cursor: pointer;">停车时间:{{item.startDate}}</p>
          <p style="color: #bbb;cursor: pointer;">停车时长:{{item.stopTime}}</p>
          <p style="cursor: pointer;color: #bbb;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;">
            地址:{{item.address}}</p>
        </div>
        <div style="clear: both"></div>
      </Card>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { GPS } from '@/libs/positonUtils'
  import store from '@/store'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
  import moment from 'moment'

  import { reqReverseGeocoderDetail, reqReverseGeocoder, reqSearchDirection } from '@/libs/baidumaputil'
    export default {
        name: "parking-information",
      props: {
        trips: {
          required: true
        },
      },
      data(){
          return{
            // 停车点信息框
            stopBtn: true,
            stopShow: false,
            stopInfo: [],

            trips:null,


            stopChecked: false,
            stopDateTimeCheck: null,
          }
      },
      methods:{
        // 显示停车右侧信息卡片
        showStopInfo () {
          this.stopShow = true
          this.stopBtn = false
        },
        // 影藏停车右侧信息卡片
        hideStopInfo () {
          this.stopShow = false
          this.stopBtn = true
        },
        // 停车信息点居中放大显示
        toStopLocation (data) {
          console.log('点击停车信息，切换地图位置')
          console.log(data)
          this.$emit('toStopLocation',data)
          // this._map.centerAndZoom(data.location, 18)
        },
        gettrips(trips){
          this.stopInfo = []

console.log('停车'+trips)

          const tripstop = []
          trips.forEach((value, index) => {

            if (value.tripType === 0) {
              //
              // // 格式化停车开始与结束时间
              // let startStopDate = moment(value.startDatetime).locale('zh-cn').format('lll')
              // let endStopDate = moment(value.endDatetime).locale('zh-cn').format('lll')
              // // 通过时间计算时间长度
              // let difftime = moment(value.endDatetime).diff(moment(value.startDatetime))
              // let duration = moment.duration(difftime)
              // let timeData = duration.hours() + '小时' + duration.minutes() + '分钟' + duration.seconds() + '秒'

              // 百度逆地址解析停车地址信息
              // let addressInfo
              // new Promise.resolve(
              // let stop = new Promise.resolve(reqReverseGeocoder(value.startLat, value.startLon, address => {
              //   addressInfo = address
              //   if (this.stopChecked === true) {
              //     if (difftime >= this.stopDateTimeCheck * 60000) {
              //       this.stopInfo.push({
              //         'startDate': startStopDate,
              //         'endDate': endStopDate,
              //         'stopTime': timeData,
              //         'address': addressInfo,
              //         'Lat': value.startLat,
              //         'Lon': value.startLon,
              //         // 'location': poiPoint,
              //         'sortTime': value.startDatetime
              //       })
              //       // this.stopInfo.sort(this.numsort('sortTime'))
              //     }
              //   } else {
              //     this.stopInfo.push({
              //       'startDate': startStopDate,
              //       'endDate': endStopDate,
              //       'stopTime': timeData,
              //       'address': addressInfo,
              //       'Lat': value.startLat,
              //       'Lon': value.startLon,
              //       // 'location': poiPoint,
              //       'sortTime': value.startDatetime
              //     })
              //     // this.stopInfo.sort(this.numsort('sortTime'))
              //   }
              // })
              // );
              // tripstop.push(stop);
              //
              // Promise.all(tripstop).then(res => {
              //   console.log(res)
              // })

              // );


              this.getreqReverseGeocoder(value)

            } else {
              // let startTime = moment(value.startDatetime).locale('zh-cn').format('lll')
              let startTime = new Date(value.startDatetime).Format('yyyy年MM月dd日 hh:mm:ss')
              let endTime = moment(value.endDatetime).locale('zh-cn').format('lll')

              let difftime = moment(value.endDatetime).diff(moment(value.startDatetime))
              let duration = moment.duration(difftime)
              let timeData = duration.hours() + '小时' + duration.minutes() + '分钟' + duration.seconds() + '秒'

              // let p1 = this.aMapToScreenPoint(value.startLat, value.startLon)
              // let p2 = this.aMapToScreenPoint(value.endLat, value.endLon)

              // reqReverseGeocoder(value.startLat, value.startLon, startAddress => {
              //   let startAds = startAddress
              //   reqReverseGeocoder(value.endLat, value.endLon, endAddress => {
              //     if (this.travelChecked === true) {
              //       if (difftime >= this.travelDateTimeCheck * 60000) {
                      // this.travelInfo.push({
                      //   'startDate': startTime,
                      //   'endDate': endTime,
                      //   'travelTime': timeData,
                      //   'startAddress': startAds,
                      //   'endAddress': endAddress,
                      //   'startLon': value.startLon,
                      //   'startLat': value.startLat,
                      //   'endLon': value.endLon,
                      //   'endLat': value.endLat,
                      //   'totalGpsMileage': value.totalGpsMileage,
                      //   'sortTime': value.startDatetime
                      // })
                      // this.travelInfo.sort(this.numsort('sortTime'))
                    // }
                  // } else {
                    // this.travelInfo.push({
                    //   'startDate': startTime,
                    //   'endDate': endTime,
                    //   'travelTime': timeData,
                    //   'startAddress': startAds,
                    //   'endAddress': endAddress,
                    //   'startLon': value.startLon,
                    //   'startLat': value.startLat,
                    //   'endLon': value.endLon,
                    //   'endLat': value.endLat,
                    //   'totalGpsMileage': value.totalGpsMileage,
                    //   'sortTime': value.startDatetime
                    // })
                    // this.travelInfo.sort(this.numsort('sortTime'))
                  // }
                // })
              // })
            }
          })
        },



        async getreqReverseGeocoder(value){

          // 格式化停车开始与结束时间
          let startStopDate = moment(value.startDatetime).locale('zh-cn').format('lll')
          let endStopDate = moment(value.endDatetime).locale('zh-cn').format('lll')
          // 通过时间计算时间长度
          let difftime = moment(value.endDatetime).diff(moment(value.startDatetime))
          let duration = moment.duration(difftime)
          let timeData = duration.hours() + '小时' + duration.minutes() + '分钟' + duration.seconds() + '秒'

          let addressInfo
          await reqReverseGeocoder(value.startLat, value.startLon, address => {
            addressInfo = address
            if (this.stopChecked === true) {
              if (difftime >= this.stopDateTimeCheck * 60000) {
                this.stopInfo.push({
                  'startDate': startStopDate,
                  'endDate': endStopDate,
                  'stopTime': timeData,
                  'address': addressInfo,
                  'Lat': value.startLat,
                  'Lon': value.startLon,
                  // 'location': poiPoint,
                  'sortTime': value.startDatetime
                })
                // this.stopInfo.sort(this.numsort('sortTime'))
              }
            } else {
              this.stopInfo.push({
                'startDate': startStopDate,
                'endDate': endStopDate,
                'stopTime': timeData,
                'address': addressInfo,
                'Lat': value.startLat,
                'Lon': value.startLon,
                // 'location': poiPoint,
                'sortTime': value.startDatetime
              })
              // this.stopInfo.sort(this.numsort('sortTime'))
            }
          })

        },
      },
      computed: {
        _trips: {
          get () {
            return this.trips
          },

          set (val) {
            // this.$emit('input', val)
            // this.$emit('change', val)
          }
        },
      },

      mounted() {
      }
    }
</script>

<style scoped>
  .return-btn {
    width: 100px;
    height: 30px;
    position: absolute;
    right: 10px;
    top: 0;
    z-index: 101
  }
  .stop-info-bar {
    height: 100%;
    width: 300px;
    background: #fff;
    position: absolute;
    overflow: auto;
    z-index: 100;
    right: 0;
    top: 0;
  }

  .info-card .ivu-card {
    border-radius: 0;
  }

  .info-card .left {
    width: 20%;
    float: left;
  }

  .left .img {
    margin-top: 10px;
  }

  .info-card .right {
    width: 80%;
    float: right;
  }
</style>
